export default function componentStyleOverrides(theme) {
    const bgColor = theme?.customization?.theme === 'dark' ? theme.colors?.darkLevel2 : theme.colors?.grey50;
    return {
        MuiButton: {
            styleOverrides: {
                root: {
                    fontWeight: 500,
                    borderRadius: '4px',
                    "&.Mui-disabled": {
                        backgroundColor: theme.primaryDark,
                        color: theme.darkTextPrimary,
                        opacity: 0.5
                    }
                }
            }
        },
        MuiPaper: {
            defaultProps: {
                elevation: 0
            },
            styleOverrides: {
                root: {
                    backgroundImage: 'none'
                },
                rounded: {
                    borderRadius: `${theme?.customization?.borderRadius}px`
                }
            }
        },
        MuiCardHeader: {
            styleOverrides: {
                root: {
                    color: theme.colors?.textDark,
                    padding: '24px'
                },
                title: {
                    fontSize: '1.125rem'
                }
            }
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: '24px'
                }
            }
        },
        MuiCardActions: {
            styleOverrides: {
                root: {
                    padding: '24px'
                }
            }
        },
        MuiListItemButton: {
            styleOverrides: {
                root: {
                    color: theme.darkTextPrimary,
                    paddingTop: '10px',
                    paddingBottom: '10px',
                    '&.Mui-selected': {
                        color: theme.menuSelected,
                        backgroundColor: theme.menuSelectedBack,
                        '&:hover': {
                            backgroundColor: theme.menuSelectedBack
                        },
                        '& .MuiListItemIcon-root': {
                            color: theme.menuSelected
                        }
                    },
                    '&:hover': {
                        backgroundColor: theme.menuSelectedBack,
                        color: theme.menuSelected,
                        '& .MuiListItemIcon-root': {
                            color: theme.menuSelected
                        }
                    }
                }
            }
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    color: theme.darkTextPrimary,
                    minWidth: '36px'
                }
            }
        },
        MuiListItemText: {
            styleOverrides: {
                primary: {
                    color: theme.textDark
                }
            }
        },
        MuiInput: {
            styleOverrides: {
                underline: {
                    "&:before": {
                        borderBottomColor: theme.darkTextPrimary
                    },
                    ".status-default &.MuiInput-underline:before": {
                        borderBottomColor: theme.colors.grey400
                    },
                    ".status-modified &.MuiInput-underline:before": {
                        borderBottomColor: theme.colors?.successDark
                    },
                    ".status-invalid &.MuiInput-underline:before": {
                        borderBottomColor: theme.colors?.errorMain
                    }
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    ".status-default &": {
                        color: theme.darkTextPrimary
                    },
                    ".status-modified &": {
                        color: theme.colors?.successDark
                    },
                    ".status-invalid &": {
                        color: theme.colors?.errorMain
                    }
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    color: theme.textDark,
                    '&::placeholder': {
                        color: theme.darkTextSecondary,
                        fontSize: '0.875rem'
                    }
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    background: bgColor,
                    borderRadius: `${theme?.customization?.borderRadius}px`,
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: theme?.customization?.theme === 'dark' ? theme.colors?.darkTextSecondary : theme.colors?.grey400
                    },
                    '&:hover $notchedOutline': {
                        borderColor: theme?.customization?.theme === 'dark' ? theme.colors?.darkTextPrimary : theme.colors?.primaryLight
                    },
                    '&.MuiInputBase-multiline': {
                        padding: 1
                    }
                },
                input: {
                    fontWeight: 500,
                    background: bgColor,
                    padding: '15.5px 14px',
                    borderRadius: `${theme?.customization?.borderRadius}px`,
                    '&.MuiInputBase-inputSizeSmall': {
                        padding: '10px 14px',
                        '&.MuiInputBase-inputAdornedStart': {
                            paddingLeft: 0
                        }
                    }
                },
                inputAdornedStart: {
                    paddingLeft: 4
                },
                notchedOutline: {
                    borderRadius: `${theme?.customization?.borderRadius}px`
                }
            }
        },
        MuiSlider: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        color: theme.colors?.grey300
                    }
                },
                mark: {
                    backgroundColor: theme.paper,
                    width: '4px'
                },
                valueLabel: {
                    color: theme?.colors?.primaryLight
                }
            }
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    borderColor: theme.divider,
                    opacity: 1
                }
            }
        },
        MuiAvatar: {
            styleOverrides: {
                root: {
                    color: theme.colors?.primaryDark,
                    background: theme.colors?.primary200
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    '&.MuiChip-deletable .MuiChip-deleteIcon': {
                        color: 'inherit'
                    }
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    color: theme.paper,
                    background: theme.colors?.grey700
                }
            }
        },
        MuiPickersTextField: {
            styleOverrides: {
                root: {
                    // 평소 underline
                    "& .MuiPickersInputBase-root::before": {
                        borderBottomColor: theme.darkTextPrimary
                    },

                    // 상태별 색상
                    "&.status-default .MuiPickersInputBase-root::before": {
                        borderBottomColor: theme.colors.grey400
                    },
                    "&.status-modified .MuiPickersInputBase-root::before": {
                        borderBottomColor: theme.colors?.successDark
                    },
                    "&.status-invalid .MuiPickersInputBase-root::before": {
                        borderBottomColor: theme.colors?.errorMain
                    },

                    // 라벨 색상
                    "&.status-default .MuiInputLabel-root": {
                        color: theme.colors.grey400
                    },
                    "&.status-modified .MuiInputLabel-root": {
                        color: theme.colors?.successDark
                    },
                    "&.status-invalid .MuiInputLabel-root": {
                        color: theme.colors?.errorMain
                    },

                    // 달력 아이콘 색상
                    "&.status-default .MuiIconButton-root": {
                        color: theme.colors.grey400
                    },
                    "&.status-modified .MuiIconButton-root": {
                        color: theme.colors?.successDark
                    },
                    "&.status-invalid .MuiIconButton-root": {
                        color: theme.colors?.errorMain
                    }
                }
            }
        }
    };
}
